import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import HeroSection from './sections/HeroSection';
import StatsSection from './sections/StatsSection';
import ImpactSection from './sections/ImpactSection';
import AboutSection from './sections/AboutSection';
import SuccessSection from './sections/SuccessSection';
import DonationSection from './sections/DonationSection';
import Footer from '../layout/Footer';
import '../styles.css';

const LandingPage: React.FC = () => {
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [donationAmount, setDonationAmount] = useState<number>(0);
  const [showError, setShowError] = useState<string>('');

  const handleSuccess = (amount: number) => {
    setDonationAmount(amount);
    setShowSuccess(true);
    setShowError('');
    // Scroll to success message
    setTimeout(() => {
      document.getElementById('success-message')?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleError = (error: string) => {
    setShowError(error);
    setShowSuccess(false);
  };

  const scrollToDonate = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('donate')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleMakeAnotherDonation = () => {
    setShowSuccess(false);
    setDonationAmount(0);
    document.getElementById('donate')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="page-container">
      <Navbar onDonateClick={scrollToDonate} />
      <HeroSection onDonateClick={scrollToDonate} />
      
      <ImpactSection />
      
      {/* Success Message */}
      {showSuccess && (
        <SuccessSection 
          donationAmount={donationAmount} 
          onMakeAnotherDonation={handleMakeAnotherDonation} 
        />
      )}
<StatsSection />
      <DonationSection 
        showError={showError}
        onSuccess={handleSuccess}
        onError={handleError}
      />
      <AboutSection />
      <Footer />
    </div>
  );
};

export default LandingPage;